import React, { Component } from "react";
import { connect } from "react-redux";
import "./TopNav.css";
import { Navbar, Nav, NavItem} from "react-bootstrap";

class TopNav extends Component {
  state = {
    loggingIn: false,
    activeItem: "home",
  };

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });
  render() {
    return (
      <Navbar fixedTop default collapseOnSelect>
        <div className="top-bar clearfix">
          <div className="container-bar">
            <Navbar.Header>
              <Navbar.Brand>
                <a href="/">CrystalPayrol API</a>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse style={{ position: "relative", float: "right" }}>
              <Nav pullRight>
                <NavItem eventKey={2} href="/signin">
                  <span style={{ color: "#fff" }}>Logout</span>
                </NavItem>
              </Nav>
            </Navbar.Collapse>
          </div>
        </div>
      </Navbar>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn,
  };
}

const connectedLoginPage = connect(mapStateToProps)(TopNav);
export { connectedLoginPage as TopNav };
